/**
 * IconXLogo Component
 *
 * Custom SVG icon for X (formerly Twitter).
 * Matches Phosphor icon API (size, color props).
 *
 * Note: Available in @phosphor-icons/react as 'XLogo'
 * We keep custom component for consistent styling
 */
export const IconXLogo = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill={color}
      {...props}
    >
      {/* X logo path from Phosphor icons */}
      <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.29l62.6,98.38-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z" />
    </svg>
  );
};

export default IconXLogo;
